import { render, staticRenderFns } from "./GiftCardListPane.vue?vue&type=template&id=256b2eaa&scoped=true"
import script from "./GiftCardListPane.vue?vue&type=script&lang=js"
export * from "./GiftCardListPane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardListPane.vue?vue&type=style&index=0&id=256b2eaa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b2eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256b2eaa')) {
      api.createRecord('256b2eaa', component.options)
    } else {
      api.reload('256b2eaa', component.options)
    }
    module.hot.accept("./GiftCardListPane.vue?vue&type=template&id=256b2eaa&scoped=true", function () {
      api.rerender('256b2eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardListPane.vue"
export default component.exports